var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 36,
    viewBox: "0 0 329 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6128 8.41724L70.179 26.9362L65.5129 35.2817L51.0859 8.41724H59.6128Z",
    fill: "url(#paint0_linear_44_12199)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6759 8.41724L73.508 19.5758L72.7045 12.4963L66.3223 8.41724H79.6759Z",
    fill: "#31F6A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.086 8.41895L55.6487 16.7628L45.0844 35.1994H36.5557L51.086 8.41895Z",
    fill: "#24B4D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M51.086 8.41895L50.2954 9.96434L55.6487 16.7628L51.086 8.41895Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.512 10.558V32.8841H113.268L99.5593 18.1524V32.8841H93.3154V11.4202L99.5593 9.98315L113.268 24.7105V10.558H119.512Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.427 28.0153H150.075L148.429 32.8841H125.333V9.98315H150.075L148.429 14.8519H131.427V19.0149H147.273V23.9015H131.427V28.0153Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.439 9.98315H181.753L170.643 21.2774L182.093 32.8841H174.779L166.089 24.005L157.398 32.8841H150.075L161.525 21.2774L150.415 9.98315H157.739L166.089 18.5364L174.439 9.98315Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.093 9.98315H209.745L208.042 14.8519H198.153V32.8841H191.847V14.8519H182.093V9.98315Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.745 9.98315H216.411L221.468 27.0179L228.914 9.98315H232.777L240.223 27.0179L245.28 9.98315H251.951L243.367 32.6395L237.048 34.1564L230.843 19.1532L224.441 32.6395L218.117 34.1564L209.745 9.98315Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M260.645 25.3462H267.731L262.79 16.0796L253.954 32.8841H247.585L259.632 11.4202L265.676 9.98315L278.148 32.8841H271.778L270.177 29.8925H258.426L260.645 25.3462Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M289.985 32.8841H283.682V24.9735L270.871 9.98315H278.184L286.875 20.7033L295.565 9.98315H302.889L289.995 25.0941L289.985 32.8841Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_12199",
    x1: 51.0859,
    y1: 21.8495,
    x2: 70.179,
    y2: 21.8495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24B4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#31F6A9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5873c4325e7bb4013e033d2e5be49dbc.svg";
export { ForwardRef as ReactComponent };